import { Dispatch, SetStateAction } from "react";
import { AccessLevel, DenominationOptionValues, section } from "./types";


export type topActionButton = {
  action: string;
  displayName: string;
  blueprintApi?: string;
  renderCustomComponent?: boolean;
  navigateTo?: string;
  method?: string;
  args?: [];
  actionType?: string;
};

export interface BulkUploadAction extends topActionButton {
  templateDownloadUrl: string,
  uploadUrl: string,
  fileUploadFieldLabel?: string,
  templateFileNamePrefix?: string
};

export type Field = {
  field: string;
  displayName: string;
  fieldType: string;
  toolTip?: string;
  editable: boolean;
  allowEdit?: string[];
  value?: any;
  isGroupedField?: boolean;
  order?: number;
  api?: string;
  rules?: any[];
  childEntity?: string;
  showOnlyInCreate?: boolean;
  iterate?: boolean;
  isCascade?: boolean;
  hidden?: boolean;
  actionInfo?: ActionInfo;
  display?: boolean;
  visibilityCriteria?: string;
  childField?:any,
  placeholder?:string,
  values?:any,
  apiExecutionCriteria?: ApiCriteria,
  hooks?: Array<FieldLevelHook>
  editFields?: Field[],
  isChildForm?: boolean,
  actions?: FieldLevelAction[],
  updatable?: boolean,
  creatable?: boolean;
  excludeInTotal?: boolean;
  icon?:string;
};

export interface ChildForm extends Field{
  editFields?: Field[],
  isChildForm?: boolean,
  actions?: FieldLevelAction[],
  displayType?: string,
  detailSections: section[],
  relatedInfoBlueprintApi?:string[]
  relatedInfoShowSearch?:boolean
}

export type FieldLevelAction = {
  executeOn: string,
  operations: FieldLevelActionOperation[]
}

export type FieldLevelActionOperation = {
  name: string,
  method?: string,
  api?: string,
  operations?: FieldLevelActionOperation[],
  mappings?: FieldWithApiMapping[],
  executionCriteria?: string,
  errorMessage?:string
}

export type FieldWithApiMapping = {
  key: string,
  value: string
}

export type FieldLevelHook = {
  action: string,
  type: string,
  method: string
}

export type ApiCriteria = {
  type: string,
  values?: Array<ApiValues> 
}

export type  ApiValues = {
  api: string,
  criteria: string,
  dropdownCode?: string,
  dropdownValue?: string
}

export type ActionInfo = {
  type: string;
  blueprintApi?: string;
  title?: string;
  launchMode?: string;
  allowEdits?: boolean;
};

export type Rule = {
  mandatory: boolean;
  pattern?: any;
};

export interface DropdownRules extends Rule {
  isMulti: boolean;
  maxSize: number;
  minSize: number;
  allowValues: string;
  default: string;
  showOnlyValue?: boolean
}

export interface DropdownValue extends Rule {
  code: string;
  name: string;
}

export interface DatePickerRules extends Rule {
  maxDate: string;
  minDate: string;
  default: string;
  startDate: string;
  showTime: boolean;
}
export interface FileUploadRules extends Rule {
  maxSize: 100;
  minSize: 1000;
  allowFileFormat: string;
  default: string;
  moduleName: string;
  fileContext: string;
  extraParam: string;
  maxFilesAllowed?: number;
}
export interface DropdownField extends Field {
  dropdownCode: string;
  dropdownValue: string;
  placeholder: string;
  rules: DropdownRules[];
  showOnlyValue?:boolean;
  staticDropDownValues?:[];
  defaultValue?: string;
}
export interface CascadeDropdownField extends Field {
  dropdownCode: string;
  dropdownValue: string;
  placeholder: string;
  valuesDependOnField: string;
  rules: DropdownRules[];
  showOnlyValue?:boolean;
  defaultValue?: string;
}
export interface DenominationField extends Field {
  placeholder?: string;
  selectedOptions: DenominationOptionValues[];
  optionList: any[];
  setSelectedDenominationOptions: Dispatch<SetStateAction<DenominationOptionValues[]>>;
  panelInfo?: Function;
}
export interface RadioField extends Field {
  rules: RadioRules[];
  placeholder: string;
  uiType:string;
  hideLabel?:boolean
}

export interface CheckBoxField extends Field {
  dropdownCode: string;
  dropdownValue: string;
  placeholder: string;
  rules: DropdownRules[];
}

export interface RadioRules extends Rule {
  default: string;
}
export interface TextBoxRules extends Rule {
  default: string;
  defaultType?: string;
  allowValues: string;
  maxSize?:number
}

export enum ValidationTypes {
  email,
  pan,
  adhar,
  rcNumber
}

export interface CheckBoxRules extends Rule {
  default: string;
}

export interface TextField extends Field {
  placeholder: string;
  rules: TextBoxRules[];
  lookupField?: string;
  lookupFieldEndpoint?: string;
  downloadApi?:string;
}

export interface SearchableField extends TextField {
  searchModalProps: SearchableModalProps;
}

export interface SearchableModalProps {
  dataTableBluePrint: string;
  searchFilterBluePrint: string;
  searchModalTitle: string;
  fieldIdtoMapFromBluePrint: string;
}

export interface FormulaField extends TextField {
  formula?:string;
}

export interface TextAreafield extends Field {
  placeholder: string;
  rules: TextBoxRules[];
  field: string;
}

export interface DatePickerField extends Field {
  rules: DatePickerRules[];
  placeholder: string;
}

export interface FileUploadField extends Field {
  rules: FileUploadRules[];
  placeholder: string;
}
export interface DependencyField {
  conditionValue: string;
  toBeShown: string;
}

export interface Dependency {
  field: string;
  dependencyFields: DependencyField[];
}

export interface IColumn {
  field: string;
  displayName: string;
  display: boolean;
  order: number;
  checkBox: boolean;
  title: string;
  type: string;
  align?:string;
}

export const Column: IColumn = {
  field: "",
  displayName: "",
  display: true,
  order: 0,
  checkBox: false,
  title: "",
  type: "",
};

export const Menulinkkeys = {
  users: "users",
  loans: "loans",
  trips: "trips",
  devices: "devices",
  assignments: "assignments",
  readyReckoners: "readyReckoner",
  payments: "payments",
  pdfGenerations: "pdfGeneration",
  dashboards: "dashboards",
  reports: "reports",
  reposessions: "reposession",
  pendingVerification: "pendingVerification",
  waiverSettlement: "waiverSettlement",
  fiVerification: "fiVerification",
  analytics: "analytics",
  autoRecon: "autoRecon",
  uploadSummary:"uploadSummary",
};

// this is to let all the components take title from api
export interface Props {
  title?: string;
  moduleCode?: string;
  moduleAccessLevel?: AccessLevel
}

export interface LookUpDelegateProps {
  handleLooKUp: (lookUpField: string, lookUpUrl: string) => Promise<any>;
  errorMessage: string;
  lookUpField: string;
  lookUpFieldUrl: string;
}

export type FieldLevelValidationInfo = {
  field: string,
  type?: ValidationMessageType,
  message: string
}

export enum ValidationMessageType {
  ERROR = "Error",
  INFO = "Info",
  WARNING = "Warning"
}
